import { createFileRoute } from "@tanstack/react-router";

import { CreateShopPage } from "@/components/Pages/Shops";

export const Route = createFileRoute("/_guard/shops/create")({
  component: CreateShopPage,
});
